export default "__VITE_ASSET__Sn4EgL$B__"